module.exports = __webpack_public_path__ + "img/sld_annunciator_t1_grey.6a05cb2b.svg";